"use strict";

let FlashMessages = {
    options: {
        selector: ".flash-message",
        buttonSelector: ".delete",
    },
};

FlashMessages.init = function (userOptions) {
    for (var prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

FlashMessages.initSelectors = function (rootElement) {
    const flashMessageElements = Array.prototype.slice.call(rootElement.querySelectorAll(this.options.selector), 0);

    flashMessageElements.forEach( flashMessageElement => {
        if (flashMessageElement.hasOwnProperty('moduleFlashMessagesInitialized')) { return; }
        flashMessageElement.moduleFlashMessagesInitialized = true;

        const deleteButtonElement = flashMessageElement.querySelector(this.options.buttonSelector);
        const hideAfter = flashMessageElement.dataset.hideAfter;
        setTimeout(() => {
            if (flashMessageElement.parentNode !== null) {
                flashMessageElement.parentNode.removeChild(flashMessageElement);
            }
        }, hideAfter * 1000);

        const height = deleteButtonElement.clientHeight;
        const width = deleteButtonElement.clientWidth;

        deleteButtonElement.innerHTML = `
            <svg width="${width}" height="${height}" viewBox="0 0 ${width} ${height}" xmlns="http://www.w3.org/2000/svg">
                <circle r="${Math.round(width/2)-1}" cx="${Math.round(width/2)}" cy="${Math.round(height/2)}"></circle>
            </svg>
        `;

        const circleElement = deleteButtonElement.querySelector("circle");
        circleElement.style.animationDuration = hideAfter + 's';
        circleElement.style.animationPlayState = 'running';

        deleteButtonElement.addEventListener('click', () => {
            flashMessageElement.parentNode.removeChild(flashMessageElement);
        });
    });
}

export {FlashMessages};